<app-header />

<mat-card style="margin: 0 var(--global-padding)">
  <mat-card-header>
    <mat-card-title>Microscope Details</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <app-edit
      [formGroup]="formGroup"
      permission="microscope.edit"
      (save)="onSave($event)"
      [errors]="serverErrors"
      #editComponent
    >
      <div class="input-group">
        <mat-form-field>
          <mat-label>ID</mat-label>
          <input matInput type="number" formControlName="oldMicroscopeId" required />
          <mat-hint>Numerical microscope ID. Cannot be changed.</mat-hint>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Label</mat-label>
          <input matInput formControlName="label" required />
        </mat-form-field>
      </div>

      <div class="input-group">
        <mat-form-field>
          <mat-label>Description</mat-label>
          <textarea
            matInput
            matInput
            cdkTextareaAutosize
            cdkAutosizeMinRows="2"
            formControlName="description"
          ></textarea>
        </mat-form-field>
      </div>

      <div class="input-group">
        <mat-checkbox formControlName="inUse">In use</mat-checkbox>
      </div>
    </app-edit>
  </mat-card-content>
</mat-card>
